// ----------------------------------------------------------------------
// The coaching offers and the section layout the three coaching landing pages
// share. Kept out of the content files so they can never disagree on an anchor
// — the pill row and the sections both read the ids from `COACHING_SECTIONS`.
// ----------------------------------------------------------------------

import type { ICoachingOffer } from "@/types/coaching";
import type { ILandingSections } from "@/types/landingPage";

/**
 * The coaching offers — one entry per landing page under `app/coaching-*`.
 *
 * Read by both the navbar's "Coaching" sub-drawer and the Entreprenariat
 * "Services de Coaching" cards, which used to carry two hand-written lists that
 * disagreed: the cards offered an "Individuel" and an "Organisation" coaching
 * that no page (and no menu entry) has ever backed.
 */
export const COACHING_OFFERS: ICoachingOffer[] = [
  {
    label: "Coaching professionnel",
    href: "/coaching-professionnel",
    category: "Développement professionnel",
    audience: "Dirigeants, managers & salariés",
    description:
      "Un accompagnement sur mesure pour clarifier vos objectifs, dépasser vos blocages et révéler votre plein potentiel.",
  },
  {
    label: "Coaching d’équipe",
    href: "/coaching-equipe",
    category: "Cohésion & performance",
    audience: "Équipes & services",
    description:
      "Renforcez la collaboration, la communication et la performance collective de vos équipes autour d’objectifs communs.",
  },
  {
    label: "Coaching Manager",
    href: "/coaching-manager",
    category: "Leadership",
    audience: "Managers & responsables",
    description:
      "Développez votre posture de leader, vos compétences managériales et votre capacité à mobiliser vos équipes.",
  },
];

/** Anchor ids and pill labels shared by the three coaching landing pages. */
export const COACHING_SECTIONS: ILandingSections = {
  definition: { id: "definition", label: "Définition" },
  audiences: { id: "public", label: "Pour qui ?" },
  problems: { id: "problematiques", label: "Problématiques" },
  apports: { id: "apports", label: "Apports" },
  expertRole: { id: "role-du-coach", label: "Rôle du coach" },
  process: { id: "deroulement", label: "Déroulement" },
  benefits: { id: "benefices", label: "Bénéfices" },
  cta: { id: "pourquoi", label: "Pourquoi ?" },
  faq: { id: "faq", label: "FAQ" },
};
